import React from "react";
import { Checkbox, Tooltip } from "antd";
import {
  JOURNAL_STATUS_META,
  formatDate,
  formatMoneyRub,
  stayDuration
} from "./doc-exp-utils";

const Guests = ({ record }) => {
  const osn = Number(record.cntOsn) || 0;
  const dop = Number(record.cntDop) || 0;
  if (osn <= 0 && dop <= 0) return null;
  return (
    <span className="doc-exps__guests">
      {osn > 0 ? (
        <Tooltip title="Основное">
          <span className="doc-exps__guest" data-kind="osn">
            {osn}
          </span>
        </Tooltip>
      ) : null}
      {dop > 0 ? (
        <Tooltip title="Дополнительное">
          <span className="doc-exps__guest" data-kind="dop">
            {dop}
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
};

const Stay = ({ record }) => {
  const stay = stayDuration(
    record.dateBegDate || record.dateBeg,
    record.dateEndDate || record.dateEnd,
    record.vidPutevkiRazmer
  );
  if (!stay) return null;
  return (
    <span
      className="doc-exps__stay"
      data-unit={stay.isBedDays ? "bed" : "night"}
      title={stay.isBedDays ? "койкодни" : "ночи"}
    >
      <span className="doc-exps__stay-n">{stay.n}</span>
      <span className="doc-exps__stay-u">{stay.unit}</span>
    </span>
  );
};

/**
 * Карточка строки журнала путёвок — одна в ряд.
 */
const DocExpsRowCard = ({
  record,
  selected,
  editing,
  checked,
  onCheck,
  onOpen
}) => {
  const meta = JOURNAL_STATUS_META[record.idStatus] || {
    label: record.statusName || "",
    tone: "out"
  };
  const unpaid = Number(record.symaDolg) > 0.005;
  const room = [record.numberName, record.catName].filter(Boolean).join(" · ");
  const docdate = formatDate(record.docdate);
  const dateBron = formatDate(record.dateBron);
  const dates = [formatDate(record.dateBegDate || record.dateBeg), formatDate(record.dateEndDate || record.dateEnd)]
    .filter(Boolean)
    .join(" → ");
  const discount =
    Number(record.prcSkidka) > 0 ? `−${Number(record.prcSkidka)}%` : "";

  return (
    <article
      className={[
        "doc-exps__card",
        selected ? "is-selected" : "",
        editing ? "is-editing" : "",
        record.isClosed ? "is-closed" : "",
        unpaid ? "is-unpaid" : ""
      ]
        .filter(Boolean)
        .join(" ")}
      data-status={record.idStatus}
      onClick={onOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen?.(e);
        }
      }}
    >
      <div
        className="doc-exps__card-check"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Checkbox checked={checked} onChange={(e) => onCheck?.(e.target.checked)} />
        <Tooltip title={meta.label}>
          <span className="doc-exps__status-dot-wrap" aria-label={meta.label}>
            <span className="doc-exps__status-dot" data-tone={meta.tone} />
          </span>
        </Tooltip>
      </div>

      <div className="doc-exps__card-main">
        <div className="doc-exps__card-top">
          <span className="doc-exps__card-name">{record.predName || "—"}</span>
          {record.pPhone ? (
            <span className="doc-exps__card-phone">{record.pPhone}</span>
          ) : null}
          {record.idDoc ? (
            <span className="doc-exps__card-id">#{record.idDoc}</span>
          ) : null}
          {record.vidPutevkiName || record.vidPitaniaName ? (
            <span className="doc-exps__card-type">
              {[record.vidPutevkiName, record.vidPitaniaName].filter(Boolean).join(" / ")}
            </span>
          ) : null}
        </div>
        <div className="doc-exps__card-meta">
          {docdate ? (
            <Tooltip title="Дата путёвки">
              <span className="doc-exps__card-docdate">{docdate}</span>
            </Tooltip>
          ) : null}
          {dateBron ? (
            <Tooltip title="Бронь до">
              <span className="doc-exps__card-bron">до {dateBron}</span>
            </Tooltip>
          ) : null}
          {dates ? <span>{dates}</span> : null}
          <Stay record={record} />
          <Guests record={record} />
          {room ? <span className="doc-exps__card-room">{room}</span> : null}
          {discount ? <span className="doc-exps__card-disc">{discount}</span> : null}
          {record.komment ? (
            <span className="doc-exps__card-komment">{record.komment}</span>
          ) : null}
        </div>
      </div>

      <Tooltip title={unpaid ? "Долг" : "Оплачено"}>
        <span className="doc-exps__syma doc-exps__card-syma" data-paid={unpaid ? "0" : "1"}>
          {formatMoneyRub(record.syma)}
        </span>
      </Tooltip>
    </article>
  );
};

export default DocExpsRowCard;
